import { z } from "zod";
import { PUBLICATION_STATUS } from "@/isomorphic/constants/agent-consts";

/**
 * Publication Tracking Schema
 *
 * Regroupe tous les champs liés à la publication sur le store.
 * Utilisé par les Agents et Knowledge Bases.
 *
 * Le `publicationStatus` est calculé automatiquement en fonction des dates:
 * - 'not_published': Valeur par défaut
 * - 'pending_review': Après publicationRequestedAt
 * - 'approved': Après publicationApprovedAt
 * - 'rejected': Après publicationRejectedAt
 * - 'suspended': Après publicationSuspendedAt
 */
export const PublicationTrackingSchema = z.object({
  // Status calculé automatiquement (ENUM)
  publicationStatus: z.enum(PUBLICATION_STATUS),

  // Dates de workflow
  publicationRequestedAt: z.string().nullable().optional(),
  publicationReviewedAt: z.string().nullable().optional(),
  publicationApprovedAt: z.string().nullable().optional(),
  publicationRejectedAt: z.string().nullable().optional(),
  publicationSuspendedAt: z.string().nullable().optional(),

  // Reviewer et raisons
  publicationReviewerId: z.string().nullable().optional(),
  publicationRejectionReason: z.string().nullable().optional(),
  publicationSuspensionReason: z.string().nullable().optional(),
});

// ============================================================================
// CLASSIFICATION SCHEMA
// ============================================================================

export const ClassificationSchema = z.object({
  specialty: z.string().nullable().optional(),
  usageContext: z.string().nullable().optional(),
  operations: z.array(z.string()).nullable().optional(),
  patientTypes: z.array(z.string()).nullable().optional(),
  tags: z.array(z.string()).nullable().optional(),
});

export type PublicationTracking = z.infer<typeof PublicationTrackingSchema>;
export type Classification = z.infer<typeof ClassificationSchema>;
